export default __webpack_public_path__ + "static/media/diamondTopazio.0f750d4b.svg";